/* Splus: display amounts only. Do not alter Shopify product/cart payloads. */
(() => {
  const config = document.getElementById('splus-vat-config');
  const percent = config ? JSON.parse(config.textContent).percent : 100;
  window.SplusVatDisplay = Object.freeze({
    shipping(price, country) {
      const value = Number(price);
      if (!Number.isFinite(value)) return String(price);
      return percent === 115 && country === 'Saudi Arabia'
        ? (Math.round(Math.round(value * 100) * 115 / 100) / 100).toFixed(2)
        : String(price);
    },
    amount(cents, taxable) {
      const value = Number(cents);
      if (!Number.isFinite(value)) return 0;
      return Math.round(value * (taxable === true && percent === 115 ? 115 : 100) / 100);
    }
  });
})();
